// src/pages/Customer/Cart.jsx
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const CustomerCart = () => {
  const [cartItems, setCartItems] = useState([
    { id: 1, name: "Whopper", price: 199, quantity: 2, veg: false },
    { id: 2, name: "French Fries", price: 99, quantity: 1, veg: true }
  ]);

  const [orderType, setOrderType] = useState('delivery'); // delivery, pickup, dine-in
  const [paymentMethod, setPaymentMethod] = useState('card');


   const navigate = useNavigate();

  const proceedToPayment = () => {
    // Validate cart items, calculate total, then navigate to payment
    navigate('/customer/payment', { 
      state: {
        cartItems: cartItems,
        totalAmount: total,
       
      }
    });
  };

  const updateQuantity = (id, change) => {
    setCartItems(prev => prev.map(item => 
      item.id === id 
        ? { ...item, quantity: Math.max(0, item.quantity + change) }
        : item
    ).filter(item => item.quantity > 0));
  };

  const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const deliveryFee = orderType === 'delivery' ? 40 : 0;
  const tax = subtotal * 0.05;
  const total = subtotal + deliveryFee + tax;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-6 max-w-4xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold">Your Cart</h1>
          <Link to="/customer/restaurants" className="text-red-600">Continue Shopping</Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column - Cart Items */}
          <div className="lg:col-span-2 space-y-4">
            {/* Order Type Selection */}
            <div className="bg-white rounded-lg p-4">
              <h3 className="font-semibold mb-3">Order Type</h3>
              <div className="grid grid-cols-3 gap-2">
                {['delivery', 'pickup', 'dine-in'].map(type => (
                  <button
                    key={type}
                    onClick={() => setOrderType(type)}
                    className={`p-3 rounded border ${
                      orderType === type
                        ? 'border-red-600 bg-red-50 text-red-600'
                        : 'border-gray-300'
                    }`}
                  >
                    {type === 'delivery' && '🚚 Delivery'}
                    {type === 'pickup' && '📦 Pickup'}
                    {type === 'dine-in' && '🍽️ Dine-in'}
                  </button>
                ))}
              </div>
            </div>

            {/* Cart Items */}
            <div className="bg-white rounded-lg p-4">
              <h3 className="font-semibold mb-4">Items ({cartItems.length})</h3>
              {cartItems.map(item => (
                <div key={item.id} className="flex justify-between items-center py-3 border-b">
                  <div className="flex items-center gap-3">
                    <span className={item.veg ? 'text-green-600' : 'text-red-600'}>
                      {item.veg ? '🟢' : '🔴'}
                    </span>
                    <div>
                      <h4 className="font-medium">{item.name}</h4>
                      <p className="text-gray-600">₹{item.price}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    <button 
                      onClick={() => updateQuantity(item.id, -1)}
                      className="w-8 h-8 rounded-full border flex items-center justify-center"
                    >
                      -
                    </button>
                    <span className="w-8 text-center">{item.quantity}</span>
                    <button 
                      onClick={() => updateQuantity(item.id, 1)}
                      className="w-8 h-8 rounded-full border flex items-center justify-center"
                    >
                      +
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Special Instructions */}
            <div className="bg-white rounded-lg p-4">
              <h3 className="font-semibold mb-3">Special Instructions</h3>
              <textarea 
                placeholder="Any special requests or dietary restrictions?"
                className="w-full border rounded-lg p-3 h-20"
              />
            </div>
          </div>

          {/* Right Column - Order Summary */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-lg p-4 sticky top-4">
              <h3 className="font-semibold mb-4">Order Summary</h3>
              
              <div className="space-y-2 mb-4">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span>₹{subtotal}</span>
                </div>
                <div className="flex justify-between">
                  <span>Delivery Fee</span>
                  <span>{deliveryFee === 0 ? 'FREE' : `₹${deliveryFee}`}</span>
                </div>
                <div className="flex justify-between">
                  <span>Tax (5%)</span>
                  <span>₹{tax.toFixed(2)}</span>
                </div>
                <div className="border-t pt-2 flex justify-between font-semibold">
                  <span>Total</span>
                  <span>₹{total.toFixed(2)}</span>
                </div>
              </div>

              {/* Payment Method */}
              <div className="mb-4">
                <h4 className="font-semibold mb-2">Payment Method</h4>
                <div className="space-y-2">
                  {['card', 'cash', 'upi', 'wallet'].map(method => (
                    <label key={method} className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="payment"
                        value={method}
                        checked={paymentMethod === method}
                        onChange={(e) => setPaymentMethod(e.target.value)}
                      />
                      {method === 'card' && '💳 Credit/Debit Card'}
                      {method === 'cash' && '💵 Cash on Delivery'}
                      {method === 'upi' && '📱 UPI'}
                      {method === 'wallet' && '👛 Wallet'}
                    </label>
                  ))}
                </div>
              </div>

              <button  onClick={proceedToPayment} className="w-full bg-red-600 text-white py-3 rounded-lg font-semibold hover:bg-red-700">
                Place Order • ₹{total.toFixed(2)}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerCart;